import { Logger, LoggerFactory } from "../logger";

export const sleep = (ms: number) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export class Lock {
  private locked!: Promise<void>;
  private unlocker: (() => void) | undefined;
  private name: string;
  private log: Logger;

  public constructor(name: string, locked?: boolean) {
    this.name = name;
    this.log = LoggerFactory.create(`Lock [${this.name}]`);

    if (locked === undefined || locked) {
      this.lock();
    } else {
      this.locked = Promise.resolve();
    }
  }

  public async waitForUnlock(): Promise<void> {
    this.log.debug(
      "Waiting for unlock....",
      `Seems ${this.isLocked() ? "locked" : "unlocked"}`
    );
    return await this.locked;
  }

  public lock() {
    this.log.debug("locking");

    if (this.isLocked()) {
      this.log.debug("already locked");

      return;
    }

    this.locked = new Promise(resolve => (this.unlocker = resolve));
  }

  public unlock() {
    this.log.debug("unlocking");

    if (this.unlocker) {
      this.unlocker();
      this.unlocker = undefined;
    } else {
      this.log.debug("already unlocked");
    }

    this.locked = Promise.resolve();
  }

  public isLocked() {
    const locked = !!this.unlocker;
    this.log.debug("isLocked", locked);

    return locked;
  }
}
